import React, { useState } from 'react';
import ImageModal from './ImageModal';

function CadModelingEditingGallery() {
  const [noOfElements, setNoOfElement] = useState(20);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  const galleryImages = {
    Gallery: [
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324209-663dc53147afb.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324221-663dc53dd12df.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324314-663dc59a43f2d.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324321-663dc5a1d0553.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324403-663dc5f346fb7.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324409-663dc5f988dfa.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324445-663dc61d8c363.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324452-663dc62435eb3.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324470-663dc636d6339.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324484-663dc64440f19.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324646-663dc6e6cedc3.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324653-663dc6ede9f95.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324662-663dc6f6cea31.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324668-663dc6fc4c7a7.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324675-663dc703eb2df.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324682-663dc70a1ccf7.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324688-663dc710ceb5a.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324695-663dc71732528.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324702-663dc71e26ccb.jpg',
      },
      {
        ImageGallery_MediaUrl:
          'https://cadandrender.com/adminPanel/uploads/image_gallery/1715324708-663dc7246c06e.jpg',
      },
    ],
  };

  const loadMore = () => {
    setNoOfElement(noOfElements + 20);
  };

  const openImageModal = (index) => {
    setSelectedImageIndex(index);
  };

  const closeImageModal = () => {
    setSelectedImageIndex(null);
  };

  return (
    <>
      <div className="tab-content">
        <div className="tabcontent1">
          <div className="tabcontent1GalleryInner clearfix">
            {galleryImages.Gallery.slice(0, noOfElements).map((res, index) => {
              return (
                <div className="tabcontentGallery col-3" key={index}>
                  <div className="tabcontentGalleryInner">
                    <img
                      src={`${res.ImageGallery_MediaUrl}`}
                      alt="cad-modeling-gallery"
                      onClick={() => openImageModal(index)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <button
            style={{
              display:
                noOfElements >= galleryImages.Gallery.length
                  ? 'none'
                  : 'block',
            }}
            className="loadmoreGalleryBtn"
            onClick={() => loadMore()}
          >
            LOAD MORE
          </button>
        </div>
      </div>
      {selectedImageIndex !== null && (
        <ImageModal
          images={galleryImages.Gallery}
          selectedIndex={selectedImageIndex}
          onClose={closeImageModal}
        />
      )}
    </>
  );
}

export default CadModelingEditingGallery;